import { useState } from 'react';
import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import authHeader from '../config/authHeader';

const useUsers = () => {
    const { token, logout } = useAuth();

    const [users, setUsers] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchHelper = async (url, options = {}, setState = null) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(url, {
                ...options,
                headers: authHeader(),
            });

            if (response.status === 401) return logout();
            if (!response.ok) throw new Error(`Erreur lors de la requête : ${url}`);

            const data = await response.json();
            if (setState) setState(data);
            return data;
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    const postForm = async (url, payload) => {
        setLoading(true);
        setError(null);
        const formData = new FormData();
        for (const key in payload) {
            if (payload.hasOwnProperty(key)) {
                formData.append(key, payload[key]);
            }
        }

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: authHeader(),
                body: formData,
            });

            if (response.status === 401) return logout();
            if (!response.ok) throw new Error(`Erreur lors de l'envoi POST à ${url}`);

            return await response.json();
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    const fetchUsers = () =>
        fetchHelper(`${config.apiBaseUrl}/4DACTION/KST_getUsers`, {}, setUsers);

    const fetchCAs = () =>
        fetchHelper(`${config.apiBaseUrl}/4DACTION/KST_getCAs`, {}, setUsers);

    const fetchUpdateUser = (user) =>
        postForm(`${config.apiBaseUrl}/4DACTION/KST_updateUser`, user);

    return {
        users,
        fetchUsers,
        fetchCAs,
        fetchUpdateUser
    };
};

export default useUsers;